export default "__VITE_ASSET__WCS5puuN__"